import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Dialog} from '../common/base/dialog/dialog'

export const TwContent = tw.div`
  text-left
  text-secondary
  text-sm-regular
  leading-5
  cursor-default
`

export const LoginNotAcceptedDialog = () => {
  const [show, setShow] = useState(() =>
    (location.search || '').includes('not-accepted=1')
  )

  if (!show) {
    return null
  }

  const close = () => {
    setShow(false)

    const notAccepted = (location.search || '').includes('not-accepted=1')
    if (notAccepted) {
      const search = location.search.replace('not-accepted=1', '')
      location.search = search === '?' ? '' : search
    }
  }

  return (
    <Dialog
      close={close}
      submit={close}
      title={Lang.msg.users.waitConfirmAdmin}
      width={488}
      primaryBtnText={Lang.msg.users.buttonTextDialog}
      popupInWnd
      noScroll={false}
      type="one-button"
    >
      <TwContent>{Lang.msg.users.requestSentToAdmin}</TwContent>
    </Dialog>
  )
}
